function SkeletonBar({ className = "" }) {
    return <div className={`animate-pulse rounded-md bg-slate-200/80 ${className}`.trim()} />;
}

function PlanCardSkeleton() {
    return (
        <article
            className="mx-auto flex h-full w-full max-w-[27rem] min-h-[520px] flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"
            aria-hidden
        >
            <div className="mb-8 min-h-[7.5rem]">
                <div className="mb-2 flex min-h-[1.5rem] justify-end">
                    <SkeletonBar className="h-6 w-20 rounded-full" />
                </div>
                <SkeletonBar className="mb-3 h-8 w-40 max-w-full" />
                <SkeletonBar className="h-4 w-full" />
                <SkeletonBar className="mt-2 h-4 w-4/5" />
            </div>

            <div className="mb-5 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
                <div className="flex items-baseline gap-2">
                    <SkeletonBar className="h-9 w-24" />
                    <SkeletonBar className="h-4 w-16" />
                </div>
                <SkeletonBar className="mt-4 h-3 w-20" />
                <SkeletonBar className="mt-2 h-4 w-28" />
            </div>

            <ul className="mb-6 flex flex-1 flex-col space-y-6">
                {Array.from({ length: 5 }, (_, index) => (
                    <li key={index} className="flex items-center gap-2">
                        <SkeletonBar className="h-4 w-4 shrink-0 rounded-full" />
                        <SkeletonBar className="h-4 w-40 max-w-full" />
                    </li>
                ))}
            </ul>

            <SkeletonBar className="mt-auto h-10 w-full rounded-md" />
        </article>
    );
}

function BillingToggleSkeleton() {
    return (
        <div className="mb-8 flex justify-center" aria-hidden>
            <SkeletonBar className="h-11 w-56 rounded-full" />
        </div>
    );
}

export default function PlanCardSkeletons({ count = 3, label = "Loading plans" }) {
    return (
        <div aria-busy="true" aria-label={label}>
            <BillingToggleSkeleton />
            <div className="grid auto-rows-fr items-stretch gap-5 md:grid-cols-2 xl:grid-cols-3">
                {Array.from({ length: count }, (_, index) => (
                    <PlanCardSkeleton key={index} />
                ))}
            </div>
        </div>
    );
}

export { BillingToggleSkeleton, PlanCardSkeleton };
